import Grid from "@mui/material/Grid";

import { useGetCurrentBrandingQuery } from "../../features/branding/brandingApiSlice";
import useBackgroundWithSVGPlaceholder from "../../hooks/useBackgroundWithSVGPlaceholder";

import backgroundImage from "../../assets/background.jpg";
import { defaultDomains } from "../../constants";

const LoginBackground = ({ children }) => {
	const domain = window.location.hostname;

	const backgroundImg = useBackgroundWithSVGPlaceholder(backgroundImage);
	const { data: branding } = useGetCurrentBrandingQuery();

	if (!defaultDomains.includes(domain) && !branding?.backgroundImage) {
		return (
			<Grid
				sx={{
					width: "100%",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					backgroundColor: "#999",
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
				}}
			>
				{children}
			</Grid>
		);
	}

	return (
		<Grid
			sx={{
				width: "100%",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				backgroundColor: (theme) => theme.palette.loginBg,
				backgroundImage: branding?.backgroundImage
					? `url(${branding.backgroundImage})`
					: backgroundImg,
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover",
				backgroundPosition: "center",
			}}
		>
			{children}
		</Grid>
	);
};

export default LoginBackground;
